import React, {Fragment} from 'react';
import {Edit, Submit, Form, Icon, Popup} from 'components';
import {api, partial, over, useToggle} from 'helpers';
import {store} from 'store';

export function InviteCollaborator({ popup }) {
  const [ invited, toggle ] = useToggle();
  if (invited) {
    return (
      <Fragment>
        <Popup.Menu.Item icon="plus" onClick={over(toggle, popup.bounce)}>Invite Collaborator</Popup.Menu.Item>
        <small className="secondary"><Icon name="check" /> An invitation has been sent. Once the recipient accepts it, you will be able to collaborate with him/her.</small>
      </Fragment>
    );
  }
  return (
    <Form className="compact" onSubmit={partial(invite, { popup, toggle })} delay>
      <Edit required autoFocus name="email" type="email" placeholder="Collaborator's email.." />
      <Submit icon="check" />
    </Form>
  );
}

async function invite({ popup, toggle }, { email }) {
  try {
    store.dispatch({
      type: 'COLLABORATORS_INVITE',
      email,
    });
    await api('/invite-to-collaborate', {
      emails: [ email ]
    });
    popup.bounce();
    toggle();
  } catch (error) {
    store.dispatch({
      type: 'UI_ERROR',
      errorMessage: 'Failed to add a collaborator. Please try again later.',
      error,
    });
  }
}
